import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockChip from '../components/GuideMockChip';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideProjectSearch: React.FC = () => {
  return (
    <GuidePageLayout
      title="プロジェクトを検索する"
      description="条件を指定してプロジェクトを絞り込み検索します。"
      breadcrumbs={[{ label: 'プロジェクト管理', path: '/guide/project/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: 'プロジェクト管理画面を開く' },
            {
              label: '検索条件を入力する（全て任意、未入力で全件検索）',
              description: '課長ロールの場合、初期状態で自分のIDが課長条件にセットされます。',
              content: (
                <GuideMockContainer label="検索条件チップ">
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    <GuideMockChip label="プロジェクト名: サンプル" color="info" />
                    <GuideMockChip label="ステータス: 稼働中" color="secondary" />
                    <GuideMockChip label="取引先: サンプル株式会社" color="warning" />
                    <GuideMockChip label="課長: 山田太郎" color="success" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            { label: '「検索」ボタンを押下する' },
            { label: '検索結果がプロジェクト名カナの昇順で一覧表示される' },
          ]}
        />
      </GuideSection>

      <GuideSection title="検索条件">
        <GuideTable
          headers={['項目名', '形式', '検索方法', '備考']}
          rows={[
            ['プロジェクト名', 'テキスト', '前方一致', ''],
            ['プロジェクト名（カナ）', 'カタカナテキスト', '前方一致', ''],
            ['ステータス', 'プルダウン', '完全一致', '準備中 / 稼働中 / 終了'],
            ['取引先', 'プルダウン', '完全一致', '登録済み取引先から選択'],
            ['課長', 'プルダウン', '完全一致', '課長権限ユーザーから選択'],
          ]}
        />
      </GuideSection>

      <GuideSection title="検索結果一覧の表示">
        <GuideTable
          headers={['表示項目', '位置', '説明']}
          rows={[
            ['プロジェクト名', 'メイン（左）', 'プロジェクトの表示名'],
            ['ステータスChip', 'メイン（右）', 'プロジェクトのステータスを表示'],
            ['取引先名 / 課長名', 'サブテキスト', '取引先と課長の名前'],
          ]}
        />
        <GuideMockContainer label="リスト項目の表示例">
          <Stack spacing={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="body2" fontWeight={500}>
                サンプルプロジェクト
              </Typography>
              <GuideMockChip label="稼働中" color="success" size="small" />
            </Stack>
            <Typography variant="caption" color="text.secondary">
              サンプル株式会社 / 山田太郎
            </Typography>
          </Stack>
        </GuideMockContainer>
        <GuideTable
          headers={['Chip', '意味', '表示条件', '色']}
          rows={[
            ['準備中', 'プロジェクトが準備段階', 'ステータスが PREPARING の場合', '黄（warning）'],
            ['稼働中', 'プロジェクトが稼働中', 'ステータスが ACTIVE の場合', '緑（success）'],
            ['終了', 'プロジェクトが終了', 'ステータスが CLOSED の場合', 'グレー（default）'],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>表示件数には上限があります。条件を絞って検索してください。</GuideInfoBox>
          <GuideInfoBox>
            終了したプロジェクトもステータス指定なしで検索結果に含まれます。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideProjectSearch;
